import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import { createTheme, Input } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import styled from "styled-components";
import CustomChip from "../CustomChip";

const defaultMaterialTheme = createTheme({
  palette: {
    primary: { 500: "#9240C9" },
  },
});

const getStyles = (name, value, theme) => {
  const trigger = value.findIndex((v) => v === name);
  return {
    fontFamily: trigger === -1 ? "OpenSansRegular" : "OpenSansBold",
  };
};

const Label = styled.label`
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.05em;
  color: #ff6868;
  display: block;
  margin-bottom: ${({ chipsActive, labelMargin }) =>
    chipsActive ? "0" : labelMargin ? labelMargin : "1em"};
`;

const OptionImg = styled.img`
  height: 1.5em;
  width: auto;
  margin-right: 0.5em;
`;

const useStyles = makeStyles((theme) => ({
  formControl: (props) => ({
    minWidth: 120,
    width: "100%",
    marginTop: props.noMargin ? "0px" : "36px",
  }),
}));

const useStyles2 = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "&::before": {
      borderBottom: "1px solid #dcdcdc",
    },
    "&::after": {
      borderBottom: "2px solid #9240C9",
    },
    "&:hover": {},
    "&$focused": {
      borderColor: "#9240C9",
    },
  },
  focused: {},
}));

export const CustomSelect = ({
  name,
  value,
  label,
  handleChange,
  options,
  noMargin,
  disabled,
  multiple,
  countSelected,
  checkbox,
  labelMargin,
}) => {
  const classes = useStyles({ noMargin });
  const classes2 = useStyles2();
  const inputClasses = useInputStyles();
  const theme = useTheme();
  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      {label && (
        <Label
          labelMargin={labelMargin}
          chipsActive={
            multiple &&
            !countSelected &&
            value.length > 0 &&
            value.length !== options.length &&
            true
          }
        >
          {label}
        </Label>
      )}
      <FormControl className={classes.formControl}>
        <Select
          name={name}
          fullWidth
          value={value}
          onChange={handleChange}
          disabled={disabled}
          multiple={multiple}
          input={<Input classes={inputClasses} />}
          renderValue={
            multiple
              ? (selected) => {
                  return value.length === options.length ? (
                    <span>Todos</span>
                  ) : (
                    <div className={classes2.chips}>
                      {countSelected ? (
                        <span>{`${selected.length} seleccionados`}</span>
                      ) : (
                        selected.map((value) => {
                          const matchFound = options.find(
                            (o) => o.value === value
                          );
                          return (
                            <CustomChip
                              key={value}
                              img={matchFound.img}
                              label={matchFound.label}
                              className={classes2.chip}
                            />
                          );
                        })
                      )}
                    </div>
                  );
                }
              : null
          }
        >
          {options.map((o, i) => (
            <MenuItem
              key={`menuitem-${i}`}
              value={o.value}
              style={
                Array.isArray(value) ? getStyles(o.value, value, theme) : null
              }
            >
              {checkbox && (
                <Checkbox
                  checked={value.indexOf(o.value) > -1}
                  color="primary"
                />
              )}
              {o.img && <OptionImg src={o.img} />}
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

CustomSelect.propTypes = {
  options: PropTypes.array,
};

export default CustomSelect;
